import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InvestmentRegionAllocationModel } from '../../Models/Models/PortfolioAnalysis/Investment/InvestmentRegionAllocationModel';
import { IJsonDate } from '../../System/IJsonDate';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';

declare var IS_RUNNING_IN_APP_POOL;

export class ModelPortfolioAssetRegionAllocationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(modelFundInstrumentCode: string, asAt: IJsonDate, assetClassType: AssetClassType): Promise<Array<InvestmentRegionAllocationModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioValuation/ModelPortfolioAssetRegionAllocation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { modelFundInstrumentCode: modelFundInstrumentCode, asAt: asAt, assetClassType: assetClassType }

    return AjaxWrapper.get<Array<InvestmentRegionAllocationModel>, any>(url, data);
  }
}

